import { INavData } from '@coreui/angular';
import {
  ANALYTICS,
  BROKER_DEALER,
  // CHART,
  APPS,
  COMPLIANCE,
  DOWNLOAD_APPLET,
  MANAGE_DEVICES,
  PASSWORD_POLICY,
  PHISHING,
  PageTitles,
  RELEASE_NOTES,
  SAT,
  SUPPORT,
  USERS,
  REPORTS,
  FAILING_FACTORS_REPORT,
  DEVICE_SYSTEM_LOGS,
  MY_REPORTS,
  CYBER_SECURITY_POLICY,
  RESTRICTED_APPLICATIONS_AND_PROCESSES,
  DASHBOARD,
  Roles
  // DEVICE_MIGRATION_DASHBOARD
} from '@smarsh-cyber/shared/constants';
import { FeaturePermissions } from '@smarsh-cyber/shared/models';
import { CLIENT } from '../../app.constants';

export type PortalAccess = string[];
export type PositionAccess = number[];
export const LPLKeyword = ['lpl', 'lpl-qa', 'lpl-staging', 'lpl-dev'];
export const AGKeyword = ['ag', 'advisorgroup', 'staging-ag-qa', 'staging-ag'];
export const SecureKeyword = ['secure', 'secure-staging', 'secureqa'];
export const BerthelKeyword = ['berthel'];
export const UnifyKeyword = ['unify'];
export const EnterpriseKeyword = ['enterprise'];
export const BDSecurityKeyword = ['bdsecurity', 'bdsecurity-qa'];
export const ProEquitiesKeyword = ['proequities'];
export const IFGKeyword = ['ifg'];
export const BuIds = {
  [CLIENT.SECURE]: {
    'STAGE_NL': '16d86f98-4c4e-5862-95ef-1eca59c8e309',
    'STAGE_PLANMEMBER': 'a2fe77eb-1d1f-40ec-83a9-2c5eadc8cad2',
    'STAGE_AMERITAS': 'a3defede-57dd-549d-a585-2e15a8e2daad',
    'PROD_NL': '162576b0-d86e-5f2d-bf0b-c6ebd725d565',
    'PROD_AMERITAS': 'a1b6d578-6ed5-5dcc-a689-2333c4f9d938',
    'PROD_PLANMEMBER': '936d5c0d-8137-53ff-be17-5a68baffc935'
  }
};

export const allNavList: NavList[] = [
  {
    title: true,
    name: 'Users',
    positionId: [3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.UM,
    iconComponent: { name: 'cil-people' },
    url: '/'.concat(USERS),
    //permissions: [FEATURE_ACCESS_MAP.MANAGE_USERS_READ],
    positionId: [3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.PHISHING_SIMULATION_TESTS,
    iconComponent: { name: 'cil-envelope-letter' },
    url: '/'.concat(PHISHING),
    // permissions: [FEATURE_ACCESS_MAP.PHISHING_READ],
    positionId: [3, 4],
    portalAccess: [...SecureKeyword],
    attributes: {
      'oncontextmenu': 'return false'
    },
    children: [
      {
        name: PageTitles.PHISHING_SUMMARY,
        url: 'phishing/summary'
      },
      {
        name: PageTitles.PHISHING_DETAILS,
        url: 'phishing/details'
      }
    ]
  },
  {
    name: PageTitles.SAT,
    iconComponent: { name: 'cil-education' },
    url: '/'.concat(SAT),
    // permissions: [FEATURE_ACCESS_MAP.SAT_READ],
    positionId: [3, 4],
    portalAccess: [...SecureKeyword],
    attributes: {
      'oncontextmenu': 'return false'
    },
    children: [
      {
        name: PageTitles.SAT_SUMMARY,
        url: 'sat/summary'
      },
      {
        name: PageTitles.SAT_DETAILS,
        url: 'sat/details'
      }
    ]
  },
  {
    title: true,
    name: 'Devices',
    positionId: [3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.MANAGE_DEVICES,
    iconComponent: { name: 'cil-devices' },
    url: '/'.concat(MANAGE_DEVICES),
    //permissions: [FEATURE_ACCESS_MAP.MANAGE_DEVICES_READ],
    positionId: [3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    title: true,
    name: 'Reports',
    portalAccess: [...LPLKeyword, ...AGKeyword, ...SecureKeyword],
    positionId: [0, 1, 2, 3, 4]
  },
  {
    name: PageTitles.DASHBOARD,
    iconComponent: { name: 'cil-chart-line' },
    url: '/'.concat(DASHBOARD),
    //permissions: [FEATURE_ACCESS_MAP.RAD_READ],
    positionId: [0, 3, 4],
    portalAccess: [...LPLKeyword, ...AGKeyword, ...SecureKeyword]
  },
  {
    name: PageTitles.COMPLIANCE,
    iconComponent: { name: 'cil-check' },
    url: '/'.concat(COMPLIANCE),
    //permissions: [FEATURE_ACCESS_MAP.COMPLIANCE_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.FAILING_FACTORS,
    iconComponent: { name: 'cil-clipboard' },
    url: '/'.concat(REPORTS) + '/'.concat(FAILING_FACTORS_REPORT),
    // portalAccess: [...AG_SECURE, ...LPLKeyword],
    // positionAccess: true
    // permissions: [FEATURE_ACCESS_MAP.FAILING_FACTORS_REPORT_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword,
      ...LPLKeyword
    ]
  },
  {
    name: PageTitles.ANALYTICS,
    iconComponent: { name: 'cil-speedometer' },
    url: '/'.concat(ANALYTICS),
    //permissions: [FEATURE_ACCESS_MAP.ANALYTICS_READ],
    positionId: [3, 4],
    portalAccess: [...LPLKeyword]
  },
  {
    name: PageTitles.ANALYTICS,
    iconComponent: { name: 'cil-speedometer' },
    url: '/'.concat(ANALYTICS),
    //permissions: [FEATURE_ACCESS_MAP.ANALYTICS_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...SecureKeyword,
      ...AGKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.MY_REPORTS,
    iconComponent: { name: 'cil-newspaper' },
    url: '/'.concat(REPORTS) + '/'.concat(MY_REPORTS),
    //permissions: [FEATURE_ACCESS_MAP.MY_REPORTS_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.DEVICE_SYSTEM_LOGS,
    iconComponent: { name: 'cil-find-in-page' },
    url: '/'.concat(REPORTS) + '/'.concat(DEVICE_SYSTEM_LOGS),
    //permissions: [FEATURE_ACCESS_MAP.DEVICE_SYSTEM_LOGS_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    title: true,
    name: 'Administration',
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ],
    positionId: [0, 1, 2, 3, 4]
  },
  {
    name: PageTitles.CYBER_SECURITY_POLICY,
    iconComponent: { name: 'cilLockLocked' },
    url: '/'.concat(CYBER_SECURITY_POLICY),
    // permissions: [FEATURE_ACCESS_MAP.CYBER_SECURITY_POLICY_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.DOWNLOAD_APPLET,
    iconComponent: { name: 'cil-cloud-download' },
    url: '/'.concat(DOWNLOAD_APPLET),
    //permissions: [FEATURE_ACCESS_MAP.DOWNLOAD_APPLET_READ],
    positionId: [0, 1, 2, 3],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.SUPPORT,
    iconComponent: { name: 'cilHeadphones' },
    url: '/'.concat(SUPPORT),
    //permissions: [FEATURE_ACCESS_MAP.SUPPORT_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.SUPPORT,
    iconComponent: { name: 'cilHeadphones' },
    url: 'https://rc.lpl.com/content/rc/technology/entreda-compliance-solution-faq.html',
    attributes: {
      target: '_blank'
    },
    //permissions: [FEATURE_ACCESS_MAP.LPL_SUPPORT_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [...LPLKeyword]
  },
  // {
  //   name: PageTitles.DEVICE_MIGRATION_DASHBOARD,
  //   iconComponent: { name: 'cil-spreadsheet' },
  //   url: '/'.concat(DEVICE_MIGRATION_DASHBOARD),
  //   portalAccess: [
  //     ...LPLKeyword,
  //     ...AGKeyword,
  //     ...SecureKeyword,
  //     ...BDSecurityKeyword,
  //     ...UnifyKeyword,
  //     ...EnterpriseKeyword,
  //     ...BerthelKeyword,
  //     ...ProEquitiesKeyword,
  //     ...IFGKeyword
  //   ],
  //   positionId: [4]
  // },
  {
    name: PageTitles.RELEASE_NOTES,
    iconComponent: { name: 'cil-notes' },
    url: '/'.concat(RELEASE_NOTES),
    //permissions: [FEATURE_ACCESS_MAP.RELEASE_NOTES_READ],
    positionId: [0, 1, 2, 3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.BROKER_DEALER,
    iconComponent: { name: 'cil-sitemap' },
    url: '/'.concat(BROKER_DEALER),
    //permissions: [FEATURE_ACCESS_MAP.MANAGE_ACCOUNTS_READ],
    positionId: [4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.PASSWORD_POLICY,
    iconComponent: { name: 'cil-https' },
    url: '/'.concat(PASSWORD_POLICY),
    //permissions: [FEATURE_ACCESS_MAP.PASSWORD_POLICY_READ],
    positionId: [3, 4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.APPS,
    iconComponent: { name: 'cil-apps' },
    url: '/'.concat(APPS),
    portalAccess: [...AGKeyword, ...SecureKeyword],
    positionId: [3],
    roles: [Roles.PRIMARY_SUPER_ADMIN],
    buCheck: [
      {
        portalName: [...SecureKeyword],
        buIds: [
          BuIds[CLIENT.SECURE].STAGE_NL,
          BuIds[CLIENT.SECURE].STAGE_PLANMEMBER,
          BuIds[CLIENT.SECURE].STAGE_AMERITAS,
          BuIds[CLIENT.SECURE].PROD_NL,
          BuIds[CLIENT.SECURE].PROD_AMERITAS,
          BuIds[CLIENT.SECURE].PROD_PLANMEMBER
        ]
      }
    ]
  },
  {
    name: PageTitles.RESTRICTED_APPLICATIONS_AND_PROCESSES,
    iconComponent: { name: 'cilShieldAlt' },
    url: '/'.concat(RESTRICTED_APPLICATIONS_AND_PROCESSES),
    //permissions: [
    // FEATURE_ACCESS_MAP.RESTRICTED_APPLICATIONS_AND_PROCESSES_READ
    //],
    positionId: [4],
    portalAccess: [
      ...LPLKeyword,
      ...AGKeyword,
      ...SecureKeyword,
      ...BDSecurityKeyword,
      ...UnifyKeyword,
      ...EnterpriseKeyword,
      ...BerthelKeyword,
      ...ProEquitiesKeyword,
      ...IFGKeyword
    ]
  },
  {
    name: PageTitles.OLD_PORTAL,
    iconComponent: { name: 'cilTransfer' },
    url: '[PORTAL_URL]/welcome',
    portalAccess: [...LPLKeyword, ...AGKeyword, ...SecureKeyword],
    positionId: [0, 1, 2, 3, 4]
  }
];

interface BuCheck {
  portalName: string[];
  buIds: string[];
}

export interface NavList extends INavData {
  permissions?: FeaturePermissions;
  positionId: PositionAccess; // TODO: temporarily added till we enable the feature access map
  portalAccess: PortalAccess; // TODO: temporarily added till we enable the feature access map
  roles?: Roles[];
  buCheck?: BuCheck[];
}
